// Language names in their native script
// Temporary while the language service gets ready
export const LANGUAGE_NAMES: Record<string, string> = {
  'en-US': 'English',
  'en-GB': 'English (UK)',
  'es-ES': 'Español',
  ar: 'العربية',
  'bg-BG': 'Български',
  'bn-IN': 'বাংলা',
  'cs-CZ': 'Čeština',
  'de-DE': 'Deutsch',
  'el-GR': 'Ελληνικά',
  'fi-FI': 'Suomi',
  'fr-CA': 'Français (Canada)',
  'gu-IN': 'ગુજરાતી',
  'he-IL': 'עברית',
  'hi-IN': 'हिन्दी',
  'ht-HT': 'Kreyòl Ayisyen',
  'id-ID': 'Bahasa Indonesia',
  'it-IT': 'Italiano',
  'ja-JP': '日本語',
  'kn-IN': 'ಕನ್ನಡ',
  'ko-KR': '한국어',
  'ml-IN': 'മലയാളം',
  'mr-IN': 'मराठी',
  'ms-MY': 'Bahasa Melayu',
  'nl-NL': 'Nederlands',
  'no-NO': 'Norsk',
  'or-IN': 'ଓଡ଼ିଆ',
  'pa-IN': 'ਪੰਜਾਬੀ',
  'pl-PL': 'Polski',
  'pt-BR': 'Português (Brasil)',
  'ro-RO': 'Română',
  'ru-RU': 'Русский',
  'sv-SE': 'Svenska',
  'ta-IN': 'தமிழ்',
  'te-IN': 'తెలుగు',
  'th-TH': 'ไทย',
  'tl-PH': 'Tagalog',
  'tr-TR': 'Türkçe',
  'uk-UA': 'Українська',
  'vi-VN': 'Tiếng Việt',
  'zh-CN': '中文 (简体)',
  'zh-TW': '中文 (繁體)',
};

// Convert to options format for StyledReactSelect
export const LANGUAGES = Object.entries(LANGUAGE_NAMES).map(([code, name]) => ({
  key: code,
  label: name,
}));

export const VALID_DEFAULT_LOCATION_FILTERS = [
  { key: 'current_location', label: 'Current Location' },
  { key: 'all', label: 'All Locations' },
];
